<template>
  <div class="d-flex align-center">
    <TableItemCount
      v-if="showItemCount"
      :currentPage="page"
      :itemsPerPage="itemsPerPage"
      :allElementsCount="allElementsCount"
    />
    <v-pagination
      v-if="totalPage > 1"
      v-model="page"
      :length="totalPage"
      :total-visible="7"
      active-color="teal"
      border
      rounded="lg"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import TableItemCount from '@/components/Common/TableItemCount.vue';

type Props = {
  modelValue: number,
  totalPage: number,
  itemsPerPage?: number,
  allElementsCount?: number,
  showItemCount?: boolean,
}
const props = withDefaults(defineProps<Props>(), {
  itemsPerPage: 0,
  allElementsCount: 0,
  showItemCount: false,
})
const emits = defineEmits(['update:modelValue'])

const page = computed({
  get: () => props.modelValue,
  set: (value: number) => emits('update:modelValue', value),
})
</script>

<style scoped>
:deep(.v-pagination__list) {
  margin-bottom: 0;
  padding-left:  0.5rem;
}
:deep(.v-btn) {
  font-weight: 400;
}
</style>
